import React from 'react';

interface PaymentButtonsProps {}

const PaymentButtons: React.FC<PaymentButtonsProps> = () => {
    return (
      <div className="flex flex-col sm:flex-row gap-3">
        <button
          type="submit"
          className="w-full sm:w-auto flex-grow text-white font-semibold py-3 px-6 rounded-lg transition duration-150 text-base btn-primary"
        >
          Finalizar Compra
        </button>
      </div>
    );
};


export default PaymentButtons; 